import { fetchMessage, clearSelectedMessage } from 'message/actions/message-details.actions';
import { replyMessage } from 'message/actions/reply-message.actions';

import template from './reply-message-dialog.html';

const mapStateToThis = ({ messages, retailerDetails, session }) => {
  const { selectedMessage, selectedMessages, messageDetailsLoadingStatus } = messages;
  const { selectedMessagesList } = selectedMessages;
  const { emailAddress } = session;

  return {
    selectedMessagesList,
    emailAddress,
    isLoading: messageDetailsLoadingStatus,
    message: selectedMessage,
    retailer: retailerDetails,
  };
};

const mapDispatchToThis = {
  fetchMessage,
  clearSelectedMessage,
  replyMessage,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$sce')
class ReplyMessageDialogController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    this.DIRTY_FORM = 'replyToMessage';
  }

  $onInit() {
    if (!this.message.userMessageId) {
      const [userMessageId] = this.selectedMessagesList;
      this.fetchMessage(userMessageId);
    }
  }

  $onDestroy() {
    const [userMessageId] = this.selectedMessagesList;
    if (userMessageId) {
      this.clearSelectedMessage();
    }
    this.unsubscribe();
  }

  async reply() {
    const message = {
      content: this.content,
      replyMessageId: this.message.messageId,
    };

    await this.replyMessage(message);

    this.close();
  }
}

export default class ReplyMessageDialogComponent {
  constructor() {
    this.controller = ReplyMessageDialogController;
    this.template = template;
    this.bindings = {
      resolve: '<',
      close: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/message/components/reply-message-dialog/reply-message-dialog-component.js